module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/mainvisual-title-pc_208a3f844a7cd2ac02eaf7ee716c3ec1.png";